/**
 * Validación del carrito antes de abrir el checkout.
 */

export const CART_VALIDATION_ACTION = "validate_shopping_cart_items";
const SHIPPING_CART_NOT_ACTIVE = "Shoppingcart is not active";
const SHIPPING_CART_PROCESSING_PAYMENT = "procesando_pago";

export interface CartValidationEntry {
  id: string | number;
  name: string;
  previousAmount?: number;
  currentAmount?: number;
}

export interface CartValidationResult {
  inactiveStore: boolean;
  inactiveProducts: CartValidationEntry[];
  inactiveCategories: CartValidationEntry[];
  missingReferences: CartValidationEntry[];
  changedPrices: CartValidationEntry[];
}

const toEntries = (
  items: any,
  getName: (item: any) => string
): CartValidationEntry[] =>
  Array.isArray(items)
    ? items.map((item: any) => ({
        id: item?.id,
        name: getName(item) || "",
      }))
    : [];

/**
 * Normaliza la respuesta del backend. Devuelve `null` cuando la respuesta no
 * corresponde a una validación fallida del carrito, para que el flujo de pago
 * siga su curso normal.
 */
export const getCartValidationError = (
  response: any
): CartValidationResult | null => {
  if (!response || response.success !== false) return null;

  const data = response.data || {};
  const isCartValidation =
    response.lastAction === CART_VALIDATION_ACTION ||
    data.inactiveStore === true ||
    Array.isArray(data.inactiveProducts) ||
    Array.isArray(data.inactiveCategories) ||
    Array.isArray(data.missingReferences) ||
    Array.isArray(data.changedPrices);

  if (!isCartValidation) return null;

  return {
    inactiveStore: data.inactiveStore === true,
    inactiveProducts: toEntries(data.inactiveProducts, (item) => item?.titulo),
    inactiveCategories: toEntries(
      data.inactiveCategories,
      (item) => item?.nombre
    ),
    missingReferences: toEntries(data.missingReferences, (item) => item?.nombre),
    changedPrices: Array.isArray(data.changedPrices)
      ? data.changedPrices.map((item: any) => ({
          id: item?.referenciaId || item?.id,
          name: item?.titulo || "",
          previousAmount: Number(item?.valorCarrito) || 0,
          currentAmount: Number(item?.valorActual) || 0,
        }))
      : [],
  };
};

export const getShippingErrors = (response: any): string[] | null => {
  if (response?.success === true) return null;
  if (
    response?.titleResponse === SHIPPING_CART_NOT_ACTIVE &&
    response?.textResponse === SHIPPING_CART_PROCESSING_PAYMENT
  ) {
    return null;
  }

  const list = response?.data?.errors ?? response?.data?.errores;
  const messages: string[] = Array.isArray(list)
    ? list.map((item: any) => item?.errorMessage).filter(Boolean)
    : [];

  return messages.length > 0
    ? messages
    : [response?.titleResponse || "shipping_unknown_error"];
};
